import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = async (_route, _state) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  await authService.ensureSession().catch(() => null);

  const user = authService.user();

  if (!user) {
    return router.createUrlTree(['/admin']);
  }

  // All authenticated users with allowed domains are approved
  return true;
};

